import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "login",
  //   component: () => import("@/views/login"),
  // },

  {
    path: "/",
    name: "login_v2",
    component: () => import("@/views/login/login_v2.vue"),
  },
  {
    path: "/appPage",
    name: "appPage",
    component: () => import("@/views/appPage.vue"),
  },
  {
    name: "Home",
    path: "/home",
    component: () => import("@/views/home"),
    redirect: {
      name: "homePage",
    },
    children: [
      {
        name: "homePage",
        path: "homePage",
        component: () => import("@/views/home/homePage.vue"),
        meta: {
          title: "首页",
          breadcrumb: [
            {
              path: "",
              title: "首页",
            },
          ],
        },
      },
      {
        name: "roleManagerList",
        path: "roleManagerList",
        component: () => import("@/views/home/roleManager/roleManagerList.vue"),
        meta: {
          title: "角色管理",
          breadcrumb: [
            {
              path: "",
              title: "权限管理",
            },
            {
              path: "",
              title: "角色管理",
            },
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: "userManagerList",
        path: "userManagerList",
        component: () => import("@/views/home/userManager/userManagerList.vue"),
        meta: {
          title: "系统用户",
          breadcrumb: [
            {
              path: "",
              title: "权限管理",
            },
            {
              path: "",
              title: "系统用户",
            },
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: "merchantManagement",
        path: "merchantManagement",
        component: () => import("@/views/home/merchantManagement/index.vue"),
        meta: {
          title: "商家管理",
          breadcrumb: [
            {
              path: "",
              title: "商家管理",
            },
            {
              path: "",
              title: "商家管理",
            },
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: "merchantReview",
        path: "merchantManagement/merchantReview",
        component: () => import("@/views/home/merchantManagement/merchantReview.vue"),
        meta: {
          title: "商家审核",
          breadcrumb: [
            {
              path: "",
              title: "商家管理",
            },
            {
              path: "",
              title: "商家审核",
            },
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: "addMerchant",
        path: "merchantManagement/addMerchant",
        component: () => import("@/views/home/merchantManagement/addMerchant.vue"),
        meta: {
          title: "新增/编辑商家",
          breadcrumb: [
            {
              path: "",
              title: "商家管理",
            },
            {
              path: "/home/merchantManagement",
              title: "商家审核",
            },
            {
              path: "",
              title: "新增/编辑商家",
            },
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: "advertisingManagement",
        path: "systemManagement/advertisingManagement",
        component: () => import("@/views/home/systemManagement/advertisingManagement.vue"),
        meta: {
          title: "宣传图配置",
          breadcrumb: [
            {
              path: "",
              title: "系统设置",
            },
            {
              path: "",
              title: "宣传图配置",
            }
          ],
          // isNotrequireAuth: true
        },
      },
      {
        name: 'feedback',
        path: 'feedback',
        component: () =>
            import ('@/views/home/feedback/index.vue'),
        meta: {
          title: '意见反馈',
          breadcrumb: [{
            "path": "",
            "title": "意见反馈"
          }
        ]}
      }
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
